export class FederalElection {
    federalWithholdingStatus: string;
    fedMaritalStatus: string;
    fedNoOfExemptions: string;
    flatWithholdingAmt : string;
    fedAddWithholdingAmt: string; 
}